import { MessageEmailState } from './messageEmail.types'

const initialState: MessageEmailState = {
  loading: false,
  error: null,
  success: null
  // Initialize any additional state properties here
}

export default initialState
